import React, {Component} from 'react';
import {Factory} from './components/desktop/factory';
import {connect} from 'react-redux';

class TeamsCombinations extends Component {
    render() {
        const {sportConfig} = this.props;

        const ViewComponent = Factory.getComponent(sportConfig);

        return ViewComponent ? <ViewComponent /> : null;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const TeamsCombinationsComponent = connect(mapStatesToProps)(TeamsCombinations);

export {TeamsCombinationsComponent};
